import { Card, Empty } from "antd"
import React, { useRef } from "react"

import { ApprovalDocumentPreview } from "../../../../components/ApprovalDocumentPreview.tsx"
import { type Contract } from "../../types/types.ts"
import { ContractViewScrollTabs } from "./ContractViewScrollTabs.tsx"
import { ContractViewVersions } from "./ContractViewVersions.tsx"

interface ContractViewBodyProps {
  contract: Contract
}

export function ContractViewBody({ contract }: ContractViewBodyProps) {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const documentRef = useRef<HTMLDivElement | null>(null)
  const versionsRef = useRef<HTMLDivElement | null>(null)
  // const commentsRef = useRef<HTMLDivElement | null>(null)

  const fileUrl = contract?.submitted_attachment?.file_url
  const attachments = contract?.attachments
  const versionDisplayDate =
    contract?.reviewed_at || contract?.submitted_for_review_at

  return (
    <>
      <ContractViewScrollTabs
        refsMap={{
          container: containerRef,
          document: documentRef,
          versions: versionsRef
          // comments: commentsRef
        }}
      />

      <div
        ref={containerRef}
        className="flex-1 space-y-2 overflow-auto tailwind-scroll"
      >
        {fileUrl ? (
          <ApprovalDocumentPreview ref={documentRef} pdfUrl={fileUrl} />
        ) : (
          <Card>
            <Empty description={"Pdf not found"} />
          </Card>
        )}
        <div ref={versionsRef}>
          {attachments?.length ? (
            <ContractViewVersions
              attachments={attachments}
              displayDate={versionDisplayDate}
            />
          ) : (
            <Card>
              <Empty description={"Version history is empty"} />
            </Card>
          )}
        </div>
        {/*<div ref={commentsRef}>*/}
        {/*  <ContractViewComments />*/}
        {/*</div>*/}
      </div>
    </>
  )
}
